<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('是否存在设计变更')" prop="isDesignChanges">
                  <a-radio-group v-model="model.isDesignChanges">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('施工备注')" prop="constructionRemark">
                  <a-textarea v-model="model.constructionRemark" :placeholder="$t('请输入施工备注')" :rows="2" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注')" prop="remark">
                  <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')" :rows="2" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('施工附件')" prop="constructionAnnex">
                  <!-- <a-upload name="file" :multiple="false" :fileList="fileList" :beforeUpload="beforeUpload" :remove="handleRemove" @change="handleChange">
                      <a-button>
                          <a-icon type="upload" />
                          选择附件
                      </a-button>
                  </a-upload> -->
                  <JUpload v-model="fileList" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('验收附件')" prop="acceptanceAnnex">
                  <JUpload v-model="fileList1" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
            </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </a-modal>
</template>

<script>
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  export default{
    components:{JUpload},
    data() {
      return {
        title: '',
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {},
        url: {},
        fileList:[],
        fileList1:[]
      }
    },
    computed: {
      formDisabled() {
        return this.disableSubmit
      },
    },
    created() {},
    methods:{
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if (this.model.constructionAnnex == null) {
          this.fileList = []
        } else {
          this.fileList = [this.model.constructionAnnex];
        }
        if (this.model.acceptanceAnnex == null) {
          this.fileList1 = []
        } else {
          this.fileList1 = [this.model.acceptanceAnnex];
        }
        if(type == 'detail'){
          this.disableSubmit = true;
          this.title = this.$t('详情');
        }else{
          this.disableSubmit = false;
          if(this.model.id){
            this.title = this.$t('编辑');
          }else{
            this.title = this.$t('新增');
          }
        }
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
    }
  }
</script>

<style>
</style>